import React from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  errorAtom,
  successAtom,
} from '@components/subscription/store/SubscriptionAtoms';
import CancelHintPopUp from '@components/subscription/detail/hint/popup/CancelHintPopUp';
import {
  hintAddOnQueryAtom,
  hintDetailAtom,
  updateRenewalAtom,
} from '@components/subscription/store/HintPaymentAtoms';
import moment from 'moment';

const CancelHintButton = () => {
  const setSuccess = useSetAtom(successAtom);
  const setError = useSetAtom(errorAtom);
  const [isShowPopUp, setIsShowPopUp] = React.useState(false);
  const updateMutation = useAtomValue(updateRenewalAtom);
  const hintDetailQuery = useAtomValue(hintAddOnQueryAtom);
  const hintDetail = useAtomValue(hintDetailAtom);
  const expiryDate = moment(hintDetail?.expiry_date).format('D MMMM YYYY');

  async function handleCancel() {
    setIsShowPopUp(false);
    if (updateMutation.isPending || hintDetailQuery.isLoading) {
      return;
    }

    const { data } = await updateMutation.mutateAsync(false);

    if (data.error) {
      setError(data.error_msg);
    } else {
      await hintDetailQuery.refetch();
      setSuccess({
        message: 'Your hints subscription will end on ' + expiryDate,
        states: 'neutral',
        buttonText: '',
        onTextClick: () => {},
      });
    }
  }

  return (
    <>
      <div className={'text-center text-sm leading-[19px]'}>
        <div
          className={
            'text-alert-error font-bold underline cursor-pointer leading-[1.2]'
          }
          onClick={() => setIsShowPopUp(true)}
        >
          Cancel subscription
        </div>
        <div className={'text-neutral-pencil'}>to stop recurring charges</div>
      </div>
      {isShowPopUp && (
        <CancelHintPopUp
          onClose={() => setIsShowPopUp(false)}
          onConfirm={handleCancel}
          date={expiryDate}
        />
      )}
    </>
  );
};

export default CancelHintButton;
